<template>
  <Layout>
  <DsIslandsContainer>
    <DsIsland>
      <DsResultBanner
          title=""
          type="success"
          size="small"
          animated
        >
        <template #title>
          <span v-html="translate('goldkid-opened:title')"></span>
        </template>
      </DsResultBanner>
    </DsIsland>
    <DsIsland>
      <DsTitle size="h2">
        <span v-html="translate('goldkid-opened-steps:title')" />
      </DsTitle>
      <DsStepper :progress="-1" :steps="2">
        <template v-slot:step-1>
          <span v-if="getLocalePlease === 'ru'">
            Отправьте ребенку ссылку на скачивание приложения Kaspi.kz
          </span>
          <span v-else>
            Балаға Kaspi.kz қосымшасын көшіріп алуға сілтеме жолдаңыз
          </span>
        </template>
        <template v-slot:step-2>
          <span v-if="getLocalePlease === 'ru'">
            Подтвердите регистрацию с помощью Kaspi QR или по
            <a @click.prevent.stop="goToRequisites" class="text-action-link underline" href>реквизитам карты</a>
          </span>
          <span v-else>
            Тіркеуді Kaspi QR немесе <a @click.prevent.stop="goToRequisites" class="text-action-link underline" href>карта реквизиттері</a> бойынша растаңыз
          </span>
        </template>
      </DsStepper>
    </DsIsland>
    <DsIsland v-if="isGuideEnabled">
      <snippet
        :lang="getLocalePlease"
        code="KaspiGoldKidReceive"
        :title="translate('kid-list:guide-title')"
        :contour="guideContour" />
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton size="large" @click="shareDeepLink">
        {{ translate('goldkid-open:btn-download') }}
      </DsButton>
      <DsButton type="ghost" size="large" @click="location.href = `/bank/reroute/gold/index?identificator=${kidInfo.iin}`">
        {{ translate('goldkid-open:btn-goldkid') }}
      </DsButton>
    </DsButtonBar>
  </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { DsResultBanner, DsIsland, DsIslandsContainer, DsStepper, DsTitle, DsButtonBar, DsButton } from '@ds/vue2'
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import {snippet} from '@guide/guide-snippet-vue2'
import "@guide/guide-snippet-vue2/styles"
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { getLocale } from '@/modules/locale/locale'
import { computed, onMounted, ref } from 'vue';
import translate from '@/filters/translate.filter'
import useStore from '@/composables/useStore';
import useHeader from '@/composables/useHeader';
import { getDeviceType } from '@/helpers/getDeviceType'
import Layout from '@/components/ui/Layout/Layout.vue'
const location = ref(window.location)
const store = useStore()
const {hideBackBtn} = useHeader()
hideBackBtn()

const isIos = computed(() => {
  return getDeviceType() === 'ios'
})
const getLocalePlease = computed(() => {
  return getLocale() === 'ru-RU' ? 'ru' : 'kz'
})
const guideContour = process.env.VUE_APP_GUIDE_CONTOUR
const getChildName = computed(() => {
  return (kidInfo.value && kidInfo.value.firstName) || ''
})
const kidInfo = computed(() => {
  return store.getters['goldkidProcess/kidInfo'] || {}
})
const isGuideEnabled = computed(() => {
  return store.getters['goldkidProcess/isGuideTipsEnabled']
})
const goToRequisites = () =>{
  window.location.href = `/bank/reroute/gold/requisites?identificator=${kidInfo.value.iin}`
}
const shareDeepLink = () => {
  const deeplinkRU = `${getChildName.value}, для вас открыт Kaspi Gold.

Зарегистрируйтесь
в приложении Kaspi.kz:
https://dz3a4.app.goo.gl/tQvW`

  const deeplinkKZ = `${getChildName.value}, сізге арнап Kaspi Gold картасы ашылды.

Kaspi.kz қосымшасына тіркеліңіз:
https://dz3a4.app.goo.gl/tQvW`

  if (window.mobapp && window.mobapp.sharePage) {
    window.mobapp.sharePage(getLocalePlease.value === 'ru' ? deeplinkRU : deeplinkKZ)
  }
}

onMounted(() => {
  store.dispatch('goldkidProcess/dataStep')
    sendAnalyticEvent('online_child_gold_approved', {
      started_from: [store.getters['app/urlParams'].startedFrom],
      stage: ['start'],
      page_path: ['/bank/bpm/products/goldkids/goldkid'],
      external_message_id: [store.getters['goldkidProcess/pId']]
    })
    // KAFKA LOGGER
    store.dispatch('goldkidProcess/logEventToKafka', {
      ver: 1,
      usrId: store.getters['goldkidProcess/userData']?.userId,
      evt: 'gold_kid_events',
      act: 'online_child_gold_approved'
    })
    eventBus.$emit('kaspiLoading', false)
})

</script>
